"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserRealmRunner = void 0;
var realms_engine_1 = require("realms-engine");
var BrowserRealmRunner = /** @class */ (function (_super) {
    __extends(BrowserRealmRunner, _super);
    function BrowserRealmRunner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Use requestAnimationFrame on browser for better performance
     */
    BrowserRealmRunner.prototype.queueMethod = function (callback, timeMs) {
        setTimeout(callback, timeMs);
    };
    BrowserRealmRunner.prototype.getSystemTime = function () {
        return performance.now();
    };
    return BrowserRealmRunner;
}(realms_engine_1.RealmRunner));
exports.BrowserRealmRunner = BrowserRealmRunner;
